<template>
  <div
    v-if="socialMediaList.length"
    :class="classes"
    :data-preload="[$options.name]"
  >
    <span class="socialHeadline">
      {{ title }}
    </span>
    <div class="socials">
      <a
        v-for="(social, index) in socialMediaList"
        :key="index"
        class="socialItem qa-IconButton"
        rel="noreferrer noopener"
        target="_blank"
        :href="social.url"
        :title="social.title"
      >
        <Icon
          :name="social.icon"
          :original="true"
          :inline="false"
          :lazy="true"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Icon from 'Components/00-generated/Icon';
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'Social',
  components: {
    Icon,
  },
  mixins: [globalMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('core', {
      socialMediaList: ({ navigation }) => navigation.social,
      salesChannelId: ({ salesChannel: { salesChannelId } }) => salesChannelId,
    }),
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';

.social {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.socialHeadline {
  white-space: nowrap;
  font-weight: bold;
  font-size: var(--font-size-M);
  color: var(--color-mine-shaft);
  line-height: 30px;
}

.socials {
  display: flex;
}

.socialItem {
  border: 1px solid var(--color-alto);
  background: var(--color-white);
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  transition: background-color 0.1s ease-in-out, border-color 0.1s ease-in-out;
  width: 44px;
  max-width: 44px;
  height: 44px;

  & + & {
    margin-left: 8px;
  }

  &:hover {
    background: var(--color-alabaster);
  }
}

@media #{$_mediaMDown} {
  .social {
    align-items: flex-start;
  }

  .socialItem {
    flex-grow: 0;
    -ms-flex-positive: 1;
  }
}

@media #{$_mediaSDown} {
  .socialHeadline {
    text-align: left;
  }
}
</style>
